<template>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header p-3 pt-1 pb-1">
          <h2 class="modal-title fs-4">Latest availability</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$emit('close')"></button>
        </div>
        <div class="modal-body p-1 overflow-x-hidden">
          <template v-if="availabilityData.ebay != null">
            <div v-for="market in availabilityData.ebay" :key="market.ebaysite" class="container modal-listing-line border-bottom p-1 position-relative">
              <div class="row">
                <div class="col"><h3 class="fs-5 mb-0"><img src="/static/img/ebay.png" alt="eBay Logo" width="24" height="24" class="bi"><a :href="market.url" target="_blank" class="stretched-link"> eBay{{market.ebaysite}}</a></h3></div>
                <div class="col fs-5">{{market.medianPrice.toFixed(2)}} {{market.currency}}</div>
              </div>
              <div v-if="market.currency === 'USD'" class="row">
                <div class="col text-secondary">Last updated {{market.updated}}</div>
                <div class="col text-secondary">Median price, {{market.results}} results</div>
              </div>
            </div>
            <div class="container modal-listing-line border-bottom p-1 position-relative">
              <div class="row">
                <span class="text-secondary">This site contains affiliate links for which I may be compensated.</span>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvailabilityModal",
  props: {
    "deviceid": String,
  },
  emits: ['close'],
  data() {
    return {
      "device": {},
      "availabilityData": {}
    }
  },
  mounted: async function() {
    let response = await fetch(window.location.origin + "/api/device/" + this.deviceid + "/availability");
    this.availabilityData = await response.json();
  },
}
</script>

<style scoped>
h3 a {
  color: inherit;
  text-decoration: none;
}
</style>